






































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ScoreService } from "@/services/score-service";
import { UserService } from "@/services/user-service";
import { Score } from "@/model/score";
import { User } from '@/model/user';
import { Prize } from '@/model/prize';
import { UserPrize } from '@/model/userPrize';
import { signIn, signOut, signedIn, authManager} from '../utils/login';
import * as Constants from '@/utils/constants';

@Component
export default class UserDetail extends Vue {
    // data
    error: any = null;
    loading: boolean = false;
    showDismissibleAlert: boolean = false;
    showDismissibleAlertA: boolean = false;
    prizesCurrentPage: number = 1;
    scoresCurrentPage: number = 1;
    prizesPerPage: number = 10;
    scoresPerPage: number = 10;
    prizesPageOptions: Array<number> = [ 10, 25, 50 ];
    scoresPageOptions: Array<number> = [ 10, 25, 50 ];
    prizes: Prize[] = [];
    userDetail: User = {
        name: '',
        surname: '',
        email: '',
        shortCode: '',
        points: 0
    };
    userPrizes: Array<UserPrize> = [];
    userScores: Array<Score> = [];
    fields: Array<object> = [
        { key: "prize.id", label: "Id premio", sortable: true, class:"capitalize"},
        { key: "prize.title", label: "Premi", sortable: true},
        { key: "prize.value", label: "Punti", sortable: true},
        { key: "bookingDate", label: "Data prenotazione", sortable: true},
        { key: "collectionDate", label: "Data di riscossione", sortable: true},
        { key: "redeem", label: "Stato premio", sortable: false},
    ];
    fieldScores: Array<object> = [
        { key: "scoreDate", label: "Data inserimento", sortable: true},
        { key: "points", label: "Punti", sortable: true, class:"capitalize"},
        { key: "description", label: "Descrizione", sortable: true, class:"capitalize"},
        { key: "cancel", label: "Annulla"}
    ];
    dismissSecs: number = 10;
    dismissCountDown: number = 0;
    score: Score = {
        id: '',
        userCode: '',
        points: 0,
        description: '',
        scoreDate: new Date()
    }

    idToInsert: string = '';
    itemToRedeem: UserPrize = new UserPrize('', new Prize(), new Date());
    scoreToCancel: Score = new Score('', 0);
    userService: UserService = new UserService();
    scoreService: ScoreService = new ScoreService();

    token: string = "";

    @Prop()
    user: any;

    // computed
    get totalScores() {
        return this.userScores ? this.userScores.length : 0;
    }

    get totalPrizes() {
        return this.userPrizes ? this.userPrizes.length : 0;
    }

    get longPrizeList() {
        return this.userPrizes && this.userPrizes.length > 10
    }

    get longScoreList() {
        return this.userScores && this.userScores.length > 10
    }

    get isSignedIn() {
      return this.user !== null;
    }

    get isAdmin() {
      return this.user.profile.roles.indexOf(Constants.ADMIN_ROLE) > -1;
    }


    created() {
        this.token = this.user.access_token;
        this.getUser(this.$route.params.code);
        this.updateUserPrizes(this.$route.params.code);
        this.scoreService.getUserScores(this.$route.params.code, this.token).then((scores) => {
            this.userScores = scores;
        });
        this.scoreService.getAllPrizes(this.token).then((prizes) => {
            this.prizes = prizes;             
        })
    }

    // methods

    getUser(userCode: string) {
        this.userService.getUser(userCode, this.token).then((response: any) => {
            this.userDetail.name = response.name;
            this.userDetail.surname = response.surname;
            this.userDetail.email = response.email;
            this.userDetail.shortCode = response.shortCode;
            this.userDetail.points = Number(this.$route.params.points);
            this.score.userCode = response.shortCode;
        })
    }

    updateUserPrizes(userCode: string) {
        this.userService.getAllUserPrizes(userCode, this.token).then((userPrizes: Array<UserPrize>) => {
            this.userPrizes = userPrizes;
        });
    }

    openModal(userPrize: UserPrize) {
        this.itemToRedeem = userPrize;
    }

    redeemPrize() {
        this.scoreService.redeemUserPrize(this.itemToRedeem, this.token).then(response => {
            console.log(response);
            this.updateUserPrizes(this.$route.params.code);

        })
    }

    addUserPrize() {
        this.scoreService.addUserPrize(this.userDetail.shortCode, this.idToInsert, this.token).then((response) => {
            console.log('Il premio è stato aggiunto');
            this.updateUserPrizes(this.$route.params.code);
            this.updateUserPoints();
        }).catch((e) => {
            console.log(e);
        });
    }

    addScore(score: Score) {
        this.scoreService.addScore(this.score, this.token).then((response: any) => {
            if(response.status === 201) {
                this.userDetail.points += this.score.points;
                this.showDismissibleAlertA = true;
                this.dismissCountDown = 300;
                this.score.points = 0;
                this.score.description = '';
                this.updateUserPoints();
                // })
            } else {
                console.log("Errore!")
                this.showDismissibleAlertA = false;
            }
        })
    }

    clearIdtoInsert() {
        this.idToInsert = '';
    }

    countDownChanged(dismissCountDown: number) {
      this.dismissCountDown = dismissCountDown
    }

    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }

    toPrizeList() {
        this.$router.push({ name: "usersList", params: { updated: "ok" } });
    }

    updateUserPoints() {
        this.scoreService.getUserScores(this.$route.params.code, this.token).then((scores) => {
            this.userScores = scores;
            this.userDetail.points = scores.filter(score => !score.deleted && !score.expired )
                .map(score => score.points).reduce((acc, next) => acc + next);
        });
    }

    openCancelScoreConfirm(score: Score) {
        this.scoreToCancel = score;
    }

    cancelScore() {
        this.scoreService.softDeleteScore(this.scoreToCancel, this.token)
        .then(response => {
            if (response.status === 200) {
                this.updateUserPoints();
            }
            else {
                alert("Errore nella cancellazione del punteggio.");
            }
        }).catch((e) => {
            alert("Errore: " + e.message);
            console.error(e.message);
        })
    }
}
